import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../modules/core/authentication/authentication-service.service';

export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthenticationService);
    const router = inject(Router);

    const userSession = authService.getUserSession();

    if (userSession) {
        return true;
    }

    // Redirect to login page if user is not authenticated
    router.navigate(['/login']);
    return false;
};